import * as types from "./constant"

export const getLOBStart = () => {
  return {
    type: types.GET_SU_LOB_START,
  }
}
export const getLOBSuccess = payload => {
  return {
    type: types.GET_SU_LOB_SUCCESS,
    payload: payload,
  }
}
export const getLOBFail = payload => {
  return {
    type: types.GET_SU_LOB_FAILED,
    payload: payload,
  }
}
export const getLOBReset = () => {
  return {
    type: types.GET_SU_LOB_RESET,
  }
}

//Create LOB

export const CreateLOBStart = (payload) => {
    return {
      type: types.CREATE_SU_LOB_START,
      payload: payload
    }
  }
  export const CreateLOBSuccess = payload => {
    console.log(payload)
    return {
      type: types.CREATE_SU_LOB_SUCCESS,
      payload: payload,
    }
  }
  export const CreateLOBFail = payload => {
    return {
      type: types.CREATE_SU_LOB_FAILED,
      payload: payload,
    }
  }
  export const CreateLOBReset = () => {
    return {
      type: types.CREATE_SU_LOB_RESET,
    }
  }
  
  //Create LOB

export const UpdateLOBStart = (payload) => {
    return {
      type: types.UPDATE_SU_LOB_START,
      payload: payload
    }
  }
  export const UpdateLOBSuccess = payload => {
    return {
      type: types.UPDATE_SU_LOB_SUCCESS,
      payload: payload,
    }
  }
  export const UpdateLOBFail = payload => {
    return {
      type: types.UPDATE_SU_LOB_FAILED,
      payload: payload,
    }
  }
  export const UpdateLOBReset = () => {
    return {
      type: types.UPDATE_SU_LOB_RESET,
    }
  }


  // DELETE LOB :

  export const DeleteLOBStart = (payload) => {
    return {
      type: types.DEL_SU_LOB_START,
      payload: payload
    }
  }
  export const DeleteLOBSuccess = payload => {
    return {
      type: types.DEL_SU_LOB_SUCCESS,
      payload: payload,
    }
  }
  export const DeleteLOBFail = payload => {
    return {
      type: types.DEL_SU_LOB_FAILED,
      payload: payload,
    }
  }
  export const DeleteLOBReset = () => {
    return {
      type: types.DEL_SU_LOB_RESET,
    }
  }


  